<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Tipos Ocorrencia"
      :headers="tipoOcorrenciaHeaders"
      :customHeaders="customHeaders"
      :items="tiposOcorrencia"
      item-key="IdTipoOcorrencia"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroTipoOcorrencia 
      v-model="modalTipoOcorrencia"
      :tipoOcorrencia="tipoOcorrencia"
      @tipoOcorrenciaAdicionado="tipoOcorrenciaAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import TipoOcorrencia from '@/domain/tipoOcorrencia/TipoOcorrencia';
import ModalCadastroTipoOcorrencia from '@/components/tipoOcorrencia/ModalCadastroTipoOcorrencia';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'TiposOcorrenciaView',
  components: {
    GridSyclus,
    ModalCadastroTipoOcorrencia
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100014
      },
      tipoOcorrenciaHeaders: [
        { text: "ID", value: "IdTipoOcorrencia" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalTipoOcorrencia: false,
      tipoOcorrencia: new TipoOcorrencia()
    }
  },
  computed: {
    ...mapGetters(['user', 'tiposOcorrencia']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchTiposOcorrenciaSql',
      'fetchLayoutsSqlUsuario',
      'deleteTipoOcorrencia',
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100014 });
      await this.fetchTiposOcorrenciaSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalTipoOcorrencia = true;
      this.tipoOcorrencia = Object.assign({}, new TipoOcorrencia());
    },
    editItemSelected(payload) {
      if (payload && payload.IdTipoOcorrencia) {
        this.tipoOcorrencia = payload;
        this.modalTipoOcorrencia = true;
      } else if (payload.length) {
        this.tipoOcorrencia = payload[payload.length - 1];
        this.modalTipoOcorrencia = true;
      } else {
        this.showNotification({ text: "Selecione um tipo Ocorrencia para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteTipoOcorrencia(item.IdTipoOcorrencia));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os tipos ocorrência: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um tipo ocorrência para excluir.', status: 'error' });
      }
    },
    tipoOcorrenciaAdicionado() {
      this.tipoOcorrencia = Object.assign({}, new TipoOcorrencia());
    }
  },
  created() {
    changePageTitle('Tipos Ocorrência');
  }
}
</script>

<style>

</style>